document.addEventListener('DOMContentLoaded', function () {
  const productCards = document.querySelectorAll(".js-product-card");
  productCards.forEach((card) => {
    card.addEventListener("click", (event) => {
      const productCard = event.currentTarget;
      const productId = productCard.getAttribute("data-product-id");
      const productName = productCard.getAttribute("data-product-name");
      const productPrice = productCard.getAttribute("data-product-price");
      const productSku = productCard.getAttribute("data-product-sku");
      const data = {
        productId: productId,
        productName: productName,
        productPrice: Number(productPrice),
        productSku: productSku,
      };
      Shopify.analytics.publish("custom_product_clicked", { data });
    })
  })
});
